import React from "react";

import ErrorBoundary from "../../../components/ErrorBoundary";
import MemberSelect from "./MemberSelect";
import MemberSearch from "./MemberSearch";

const ChangeMember = () => {
    return (
        <>
            <ErrorBoundary>
                <MemberSelect />
            </ErrorBoundary>
            <ErrorBoundary>
                <MemberSearch />
            </ErrorBoundary>
        </>
    );
}

export default ChangeMember;
